import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { resetEditorUiMode, setEditorUiMode } from 'flow/store/redux/slice';
import { selectEditorUiMode } from 'flow/store/redux/selectors';
import { useEditorAccess } from 'flow/editor/context';
import { EditorMode } from 'flow/editor/context/constants';
import { getIsEditable, getIsReadOnly } from 'flow/service/general';
import { isDiffMode, isSnippetMode } from 'flow/store/redux/helpers';

/**
 * Toggleable function that turns on the isInDiffMode redux state, and sets
 * the editor mode to read-only only if we are not in a snippet mode (upgrade,
 * merge, etc...)
 */
export function useDiffMode() {
  const dispatch = useAppDispatch();
  const uiMode = useAppSelector(selectEditorUiMode);
  const { setEditorMode, resetEditorMode } = useEditorAccess();
  const { editorMode } = useEditorAccess();
  const inEditMode = getIsEditable(editorMode);
  const inReadOnlyMode = getIsReadOnly(editorMode);

  return () => {
    const isAlreadyInDiffMode = isDiffMode(uiMode);
    if (!isSnippetMode(uiMode) && (inEditMode || inReadOnlyMode)) {
      if (!isAlreadyInDiffMode) {
        dispatch(setEditorUiMode('diffy'));
      } else {
        dispatch(resetEditorUiMode());
      }

      if (!isAlreadyInDiffMode) {
        setEditorMode(EditorMode.ReadOnly);
      } else {
        resetEditorMode();
      }
    }
  };
}
